import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import { Stack, Typography } from "@mui/material";
import StatusChip from "@entrilia/shared/components/StatusChip";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";

interface Props {
  version: number;
  savedAt?: string;
}

const ArtifactAgentVersionLabel = ({ version, savedAt }: Props) => (
  <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
    <StatusChip
      label={`Version ${version}`}
      icon={<HistoryRoundedIcon sx={{ fontSize: 14 }} />}
      neutral
      height="smaller"
      color={(t) => t.palette.text.secondary}
    />
    {savedAt && (
      <Typography variant="caption" color="textSecondary">
        {convertISODateTime(savedAt)}
      </Typography>
    )}
  </Stack>
);

export default ArtifactAgentVersionLabel;
